<template>
  <asc-navbar-button
    icon="mdi-bell"
    :count="primaryItems.length"
    :primary-items="primaryItems"
    :secondary-items="secondaryItems"
  ></asc-navbar-button>
</template>

<script>
import AscNavbarButton from './AscNavbarButton'

export default {
  name: 'AscNotificationsButton',

  components: {
    AscNavbarButton,
  },

  props: {
    primaryItems: {
      type: Array,
      default: () => [],
    },
    secondaryItems: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
